import { FC } from "react";
import { EmptyState } from "@design-system/EmptyState/EmptyState";

interface ClientsWorkEmptyViewProps {
    hasActiveFilters: boolean;
    onClearFilters: () => void;
    onGoToTemplates: () => void;
}

export const ClientsWorkEmptyView: FC<ClientsWorkEmptyViewProps> = ({
    hasActiveFilters,
    onClearFilters,
    onGoToTemplates,
}) => {
    if (hasActiveFilters) {
        return (
            <EmptyState
                header="No work items match your filters"
                action={onClearFilters}
            />
        );
    }

    return (
        <EmptyState
            header="No work items yet"
            body="Apply a service template to a client to start tracking work here."
            ctaText="Go to templates"
            action={onGoToTemplates}
        />
    );
};
